import { Alert, AlertTitle } from '@myosh/odin-components';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

const SectionErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <Alert variant="destructive">
        <AlertTitle>{t(($) => $.errorBoundaryWarning)}</AlertTitle>
      </Alert>
    </div>
  );
};

// A crash in the filters or the grid replaces that section, not the whole page.
export const SectionErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary FallbackComponent={SectionErrorFallback}>{children}</ErrorBoundary>
);
